

export default {
  name: "About",
  data() {
    return {
      lang_label: {
        en: { label: "English" },
        id: { label: "Indonesia" },
        zh: { label: "Chinese(中文)" },
      },
    };
  },

  mounted() {
    // === Satellite Scroll Animation ===
    const satellite = this.$el.querySelector(".satellite");
    if (satellite) {
      window.addEventListener("scroll", this.handleScroll);
    }

    // === Timeline Intersection Observer ===
    const items = this.$el.querySelectorAll(".timeline-item");
    if (items.length) {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const circle = entry.target.querySelector(".timeline-circle");
              const index = entry.target.getAttribute("data-index");

              const scale = 0.8 + index * 0.2; // scale progressive
              circle.style.setProperty("--scale", scale);

              circle.classList.add("visible");
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.3 }
      );

      items.forEach((item) => observer.observe(item));
    }
  },

  beforeUnmount() {
    // cleanup biar nggak leak
    window.removeEventListener("scroll", this.handleScroll);
  },

  methods: {
    handleScroll() {
      const satellite = this.$el.querySelector(".satellite");
      if (satellite) {
        let scrollPos = window.scrollY;
        satellite.style.transform = `translateX(${-scrollPos * 0.5}px) scale(${1 + scrollPos / 1000})`;
      }
    },
  },
};

